import { Button, Divider, Grid, IconButton, Tooltip } from "@material-ui/core";
import { AddCircle } from "@material-ui/icons";
import DeleteIcon from '@material-ui/icons/Delete';
import { vendorInvoiceStyles } from "../style";
import { useGetMatchingWorkordersForInvoiceQuery } from "../vendorInvoiceSlice";
import { useGetAllActivityItemsQuery } from "features/activity/activitySlice";
import { arrayToObject } from "utils/object-util";
import { IconAI, IconInfo } from "icons";
import FormatService from "services/formatService";
import ShimmerLoader from "components/ShimmerLoader/ShimmerLoader";
import { useState } from "react";
import { AutoMatchWOsToServices } from "./AutoMatchWOsToServices";
import { IconActivityDefault } from "icons/mechanicals";
import BulkUpdateActivityDialog from "features/landing/components/MechanicalDashboard/ActivityList/BulkUpdateActivityDialog";
import { EditVendorService } from "./EditVendorInvoiceService";
import { activityStatuses } from "features/activity/activityConsts";
import AddActivityWrapper from "./AddActivityWrapper";
import { permissionProfiles } from 'components/Authorize/permissionProfiles';
import Authorize from 'components/Authorize';


const VendorInvoiceServices = ({ services, setServices, selectedVehicles, invoiceToEdit }) => {
    const classes = vendorInvoiceStyles();

    let { data: matchingWorkOrders, error: matchingWorkOrdersError, isFetching: matchingWorkOrdersFetching, refetch: refetchMatchingWorkOrders } = useGetMatchingWorkordersForInvoiceQuery({
        invoiceId: invoiceToEdit?.id,
        vehicleIds: invoiceToEdit?.vehicles?.filter(v => v.vehicleId != null)?.map(v => v.vehicleId),
        invoiceDate: invoiceToEdit?.invoiceDate
    }, { skip: !invoiceToEdit?.vehicles || !invoiceToEdit?.vehicles?.find(a => a.vehicleId != null) || !invoiceToEdit?.invoiceDate });
    let { data: activityItems, error: activityItemsError, isFetching: isLoadingActivityItems } = useGetAllActivityItemsQuery();
    activityItems = activityItems || [];
    matchingWorkOrders = matchingWorkOrders || [];

    const activityItemLookup = arrayToObject(activityItems);

    matchingWorkOrders = matchingWorkOrders.map(wo => ({
        ...wo,
        activityName: activityItemLookup?.[wo.activityItemId]?.name || '',
        formattedDate: FormatService.formatDate(wo.activityDate),
        name: `${activityItemLookup?.[wo.activityItemId]?.name || ''} - ${FormatService.formatDate(wo.activityDate)}`
    }))?.sort((a, b) => a.activityDate < b.activityDate ? 1 : -1);

    const isLoading = matchingWorkOrdersFetching || isLoadingActivityItems;

    const [openMatchWOs, setOpenMatchWOs] = useState(false);

    const onAddService = () => {
        const newService = {
            vehicleId: null,
            description: null,
            qbAccountId: null,
            quantity: null,
            unitPrice: null,
            price: null,
            workOrderId: null
        };
        const newServices = [...(services || []), newService];
        setServices(newServices);
    };

    const onFieldChange = (fieldName, value, index) => {
        const updatedServices = [...services];
        updatedServices[index] = { ...updatedServices[index], [fieldName]: value };
        setServices(updatedServices);
    };

    const onDelete = (index) => {
        const updatedServices = services.filter((_, i) => i !== index);
        setServices(updatedServices);
    };

    const matchWorkorders = () => {
        setOpenMatchWOs(true);
    }

    const [openUpdateActivity, setOpenUpdateActivity] = useState(false);
    const [activityToUpdate, setActivityToUpdate] = useState(null);

    const onClickEditActivity = (service) => {
        const matchedServices = services.filter(s => s.workOrderId === service?.workOrderId);
        const totalPrice = matchedServices.reduce((sum, s) => sum + (Number(s.price) || 0), 0);
        setActivityToUpdate({
            status: totalPrice == 0 ? activityStatuses.PendingInvoice : activityStatuses.Completed,
            activityLogId: service?.activityLogId,
            workOrderId: service?.workOrderId,
            vendorId: +invoiceToEdit?.vendorId,
            cost: totalPrice
        });
        setOpenUpdateActivity(true);
    }
    const showRecommendBtn = invoiceToEdit?.id
    const disableRecommendBtn = !services || services.length === 0 || !invoiceToEdit?.vehicles || invoiceToEdit?.vehicles?.every(a => a.vehicleId == null);

    return (
        <>
            <Grid container direction='column' spacing={1}>
                <Grid item><Divider /></Grid>
                <Grid item className={classes.serviceGroupLabel}>
                    <div>Services</div>
                    {showRecommendBtn &&
                        <div>
                            <Tooltip title="Automatic Match">
                                <Button
                                    variant="outlined"
                                    size="small"
                                    endIcon={<IconAI />}
                                    onClick={matchWorkorders}
                                    disabled={disableRecommendBtn}
                                    className={classes.matchBtn}>
                                    Recommend Matches of Work Orders
                                </Button>
                            </Tooltip>
                            {disableRecommendBtn && <Tooltip title="Please add services and select vehicles to enable automatic matching."><span><IconInfo /></span></Tooltip>}
                        </div>}
                </Grid>

                <Grid spacing={1} item xs={12} container className={classes.serviceHeaders}>
                    <Grid item>
                        &nbsp;
                    </Grid>
                    <Grid item xs={3}>Description</Grid>
                    <Grid item xs={2}>QB Category</Grid>
                    <Grid item xs={1}>Quantity</Grid>
                    <Grid item xs={1}>Unit Price</Grid>
                    <Grid item xs={1}>Price</Grid>
                    <Grid item xs={3} className={classes.linkedWorkOrders}>
                        <span style={{ marginRight: "8px" }}>Linked Work Order</span>
                        <Authorize profile={permissionProfiles.ASSETS.ASSETS_DETAIL_PAGE_ADD_ACTIVITY_LOG}>
                            <AddActivityWrapper selectedVehicles={selectedVehicles} refetchMatchingWorkOrders={refetchMatchingWorkOrders} />
                        </Authorize>
                    </Grid>
                </Grid>

                {services?.map((service, index) => {
                    return (
                        <>
                            {isLoading ? <div style={{ margin: '0.5rem' }}><ShimmerLoader height="70" width={12} /></div> :
                                <Grid spacing={1} item key={index} alignItems="center" container xs={12} className={classes.editServiceContainer}>
                                    <Grid item >
                                        <b>{index + 1}</b>
                                    </Grid>
                                    <EditVendorService
                                        onFieldChange={onFieldChange}
                                        serviceToEdit={service}
                                        index={index}
                                        selectedVehicles={selectedVehicles}
                                        matchingWorkOrders={matchingWorkOrders}
                                        activityItemLookup={activityItemLookup}
                                        services={services}
                                        setServices={setServices}
                                    />
                                    <Grid item className={classes.serviceDropDownLine}>
                                        <IconButton
                                            edge="end"
                                            aria-label="delete"
                                            onClick={() => onDelete(index)}
                                        >
                                            <DeleteIcon />
                                        </IconButton>
                                        {service?.workOrderId &&
                                            <Tooltip title="Edit Linked Work Order">
                                                <IconButton
                                                    edge="end"
                                                    aria-label="edit"
                                                    onClick={() => onClickEditActivity(service)}
                                                >
                                                    <IconActivityDefault />
                                                </IconButton>
                                            </Tooltip>}
                                    </Grid>
                                </Grid>
                            }
                            {/* {index < services.length - 1 && (
                            <Grid item xs={12}> <Divider className={classes.serviceDivider} /></Grid>
                        )} */}
                        </>
                    );
                })}

                <Grid item>
                    <Button
                        onClick={onAddService}
                        startIcon={<AddCircle />}
                    >
                        Add Service
                    </Button>
                </Grid>
            </Grid>
            {openMatchWOs && <AutoMatchWOsToServices
                services={services}
                setServices={setServices}
                invoiceToEdit={invoiceToEdit}
                open={openMatchWOs}
                onClose={() => setOpenMatchWOs(false)}
                workOrdersList={matchingWorkOrders}
            />}
            <BulkUpdateActivityDialog
                selectedRows={[activityToUpdate?.activityLogId]}
                open={openUpdateActivity}
                setOpen={setOpenUpdateActivity}
                activity={activityToUpdate}
                onClear={() => setActivityToUpdate(null)} />
        </>
    );
};

export default VendorInvoiceServices;
